import { Box, Link as ChakraLink, VStack } from '@chakra-ui/react';
import { COLOR } from '../../../../styles/const';
import { Input } from '../../input/input';
import { DialogBody } from '../dialog';
import { usePasswordResetRequest } from './hooks/use-password-reset-request';

/* IDを忘れた場合の問い合わせ先 */
const SUPPORT_MAIL_ADDRESS = 'mspsystem_support@izmc.co.jp';

export const PasswordResetRequestDialog = () => {
  const {
    Footer,
    request,
    setRequest,
    validation,
  } = usePasswordResetRequest();

  return (
    <DialogBody
      bodyProps={{ w: '600px', maxW: '100%', minW: '200px' }}
      footer={<Footer />}
    >
      <Box mb="1.5rem" fontSize="sm">
        <Box>IDをお忘れの方は、下記のメールアドレスにお問い合わせください。</Box>
        <ChakraLink
          href={`mailto:${SUPPORT_MAIL_ADDRESS}`}
          color={COLOR.bg.link}
          textDecoration="underline"
        >
          {SUPPORT_MAIL_ADDRESS}
        </ChakraLink>
      </Box>
      <VStack gap="1.5rem" w="100%">
        <Input
          placeholder="ID"
          value={request.login_id}
          onChange={(e) => setRequest({ login_id: e.target.value })}
          validations={validation.login_id}
        />
        <Input
          type="email"
          placeholder="メールアドレス"
          value={request.responsible_person_email_address}
          onChange={(e) => setRequest({ responsible_person_email_address: e.target.value })}
          validations={validation.responsible_person_email_address}
        />
      </VStack>
    </DialogBody>
  )
}
